import {RootState} from '../../store';
import {BillingProvider} from './types';

export const selectionSelector = (state: RootState): Record<string, BillingProvider> =>
    state['billing-providers'].selection as Record<string, BillingProvider>;
